import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import _ from 'lodash';
import { FullStoryAPI } from 'react-fullstory';
import { account, auth, company, datastore } from '@breezeway/brzw-react-core';
import 'react-table/react-table.css';

import './configure_rollbar';  // eslint-disable-line import/order

// Import this before the rest below so the global css (bootstrap) is loaded first
import './css/styles.scss';

import { getAuthToken } from '@common/utils/token_utils';
import { clearProfileIds } from '@common/utils/storage';
import { setPerson } from '@common/utils/rollbar';

import configureStore from './configure_store';
import Brzw from './brzw';

import './css/finally.scss';

if (process.env.GOOGLE_ANALYTICS_KEY) {
  ReactGA.initialize(process.env.GOOGLE_ANALYTICS_KEY);
}

const authToken = getAuthToken('breezeway');
const store = configureStore();
clearProfileIds();
store.dispatch(datastore.actions.getPropertyElementData());
store.dispatch(datastore.actions.getTypes());

const fullstoryKey = process.env.FULLSTORY_KEY;

const setUserData = user => {
  const { company_person: companyPerson, email: userEmail, id: userId, full_name: userName } = user;

  setPerson(user);
  if (fullstoryKey) {
    const companyRole = _.get(companyPerson, 'type_role.name');
    const companyId = _.get(companyPerson, 'company_id');
    FullStoryAPI('identify', userId, {
      displayName: userName,
      email: userEmail,
      companyId_str: _.toString(companyId),
      companyRole_str: companyRole,
    });
  }
};

if (authToken) {
  // persist login on refresh.
  store.dispatch(auth.actionsV3.signingIn());
  store.dispatch(auth.actionsV3.getCurrentUser(setUserData));
  store.dispatch(account.actionsV3.getSavedViews());
  store.dispatch(company.actions.getCompanyStartupData());
  store.dispatch(company.actions.loadBusinessHours())
}

const MAIN_NODE = document.getElementById('app-entry');

ReactDOM.render(<Brzw store={store} />, MAIN_NODE);
